module.exports = __webpack_public_path__ + "static/media/IMPACT_YOUTH_ThePlace_TUNEDIN_Alicia_Clarke.d35bb7eb.jpg";